<template>
  <div @click.self="hide" class="comp-frame_cover" v-if="show">
    <div class="comp-frame_content">
      <img :src="src" class="comp-frame_content" v-if="type === 'image'">
      <video :src="src" autoplay class="comp-frame_content" controls v-else></video>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      src: '',
      type: 'image'
    };
  },
  methods: {
    hide() {
      this.show = false;
    }
  }
};
</script>

<style>
.comp-frame_cover {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.comp-frame_content {
  max-height: 550px;
}
</style>
